// Global
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { classnames } from 'tailwindcss-classnames';
// Components
import Container from 'components/helpers/Container';
import PlaceholderWrapper from 'components/helpers/PlaceholderWrapper/PlaceholderWrapper';
import { Components } from '.generated/templates/Feature.Components.model';
import Heading, { propsFromFields } from 'components/helpers/Heading';
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import LayoutColumnsGrid, { columnCss } from 'components/helpers/LayoutColumnsGrid';
import useExperienceEditor from 'lib/sitecore/use-experience-editor';

export type LayoutTwoColumnProps = Sitecore.Override.ComponentBase &
  Components.Layout.Fields.ColumnLayout;

export type LayoutTwoColumnShellProps = {
  left: JSX.Element;
  right: JSX.Element;
};

export const LayoutTwoColumnShell = ({ left, right }: LayoutTwoColumnShellProps): JSX.Element => {
  const isEE = useExperienceEditor();
  const leftPlaceholder = left.props.rendering?.placeholders['nmdp-half-width-left'];
  const leftPlaceholderIsEmpty = leftPlaceholder?.length === 0;
  const rightPlaceholder = right.props.rendering?.placeholders['nmdp-half-width-right'];
  const rightPlaceholderIsEmpty = rightPlaceholder?.length === 0;

  return (
    <LayoutColumnsGrid columns={2}>
      {(isEE || !leftPlaceholderIsEmpty) && <div className={columnCss}>{left}</div>}
      {(isEE || !rightPlaceholderIsEmpty) && <div className={columnCss}>{right}</div>}
    </LayoutColumnsGrid>
  );
};

const LayoutTwoColumn = ({ rendering, fields }: LayoutTwoColumnProps): JSX.Element => {
  if (fields === null || fields === undefined) {
    return <MissingDataSource />;
  }

  const headingProps = propsFromFields(fields);

  return (
    <Container size="standard" dataComponent="authorable/layout/layout-two-column">
      <div className={fields?.description.value ? classnames('mb-8') : ''}>
        <Heading {...headingProps} descriptionClassName={classnames('text-base')} />
      </div>
      <LayoutTwoColumnShell
        left={<PlaceholderWrapper name="nmdp-half-width-left" rendering={rendering} />}
        right={<PlaceholderWrapper name="nmdp-half-width-right" rendering={rendering} />}
      />
    </Container>
  );
};

export default LayoutTwoColumn;
